import { BrandSlider } from "./components/brand-slider"
import React from "react"

export default function BrandSliderDemo() {
  return (
    <div className="brand-slider-demo">
      <BrandSlider />
    </div>
  )
}